import { myExperimentOverlayOptions } from "./studio-actions.constants";

export const experimentListTableColumn = [
  {
    label: "",
    value: "check_box",
    valueType: "",
    filterType: "",
    inputType: "checkbox",
    sortable: false,
    disabled: true,
  },
  {
    label: "STUDIO.NAME_COLUMN",
    value: "name",
    valueType: "",
    filterType: "input_text",
    sortable: true,
  },
  {
    label: "STUDIO.TYPE",
    value: "experiment_type",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: true,
    optionsList: "experiment_types",
  },
  {
    label: "STUDIO.COUNTRY",
    value: "country",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: true,
    optionsList: "countries",
  },
  {
    label: "STUDIO.REGION",
    value: "region",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: true,
    optionsList: "regions",
  },
  {
    label: "STUDIO.KEY_ACCOUNTS",
    value: "key_account",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: true,
    optionsList: "key_accounts",
  },
  {
    label: "STUDIO.MODIFIED_AT",
    value: "created_at",
    valueType: "",
    sortable: true,
  },
  {
    label: "STUDIO.SHARED_BY",
    value: "owner_by",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: false,
    disabled: true,
    optionsList: "users",
  },
  {
    label: "STUDIO.STATUS",
    value: "status",
    valueType: "",
    filterType: "dropdown",
    filterOptions: [],
    selectedFilterValues: [],
    sortable: true,
    disabled: true,
    optionsList: "statuses",
  },
  {
    label: "STUDIO.PUBLISHED",
    value: "published_status",
    valueType: "",
    filterType: "dropdown",
    isMultiple: false,
    filterOptions: [
      {
        label: "STUDIO.PUBLISHED",
        value: "published",
      },
      {
        label: "STUDIO.UNPUBLISHED",
        value: "unpublished",
      },
    ],
    selectedFilterValues: "",
    sortable: false,
    disabled: false,
  },
  {
    label: "",
    value: "action",
    valueType: "dot-view",
    actionList: myExperimentOverlayOptions,
    disabled: false,
  },
];
